define(function(require, exports, module) {
    'use strict';
    var $ = require('j');
    var user = require('user');
    var core = require('core');
    var MenuView = require('modules/menu/menu.view');
    var BaseView = require('common/base.view');
    const { dispatcher } = require('bundle');
    var _ = require('underscore');
    var scrollManager = require('managers/scroll.manager');
    var { DateTime } = require('luxon');

    module.exports = MenuView.extend({

        subscribe: function() {
            MenuView.prototype.subscribe.apply(this, arguments);

            this.headerClientHeight = document.querySelector('.main-header')?.clientHeight;
            this.navigationMenuNode = document.querySelector('.navigation-menu');

            dispatcher.listen('menu:items', this.render.bind(this));

            if (this.isDesktopMenu() && document.documentElement.classList.contains('root-menu-sticky')) {
                $.event.add(window, 'scroll.menu', this.handleScroll.bind(this));
            }
        },

        handleScroll: function() {
            if(!this.navigationMenuNode) {
                return;
            }

            const hasOverScroll = this.navigationMenuNode.getBoundingClientRect().top <= this.headerClientHeight;

            this.$el.toggleClass('sticky-menu', hasOverScroll);
            this.$el.parent().toggleClass('menu-padding', hasOverScroll);
        },

        handleLinkNavigate: function(e) {
            e.preventDefault();

            const logout = e.target.closest('.fn-logout');

            if (logout) {
                core.trigger('auth:action:logout');
            }

            return MenuView.prototype.handleLinkNavigate.apply(this, arguments);
        },

        _renderSideMenu: function() {
            if (this.slideMenuWcId) {
                this.$el.find('.fn-common-slide-menu').remove();

                return;
            }

            this.$el.html(this.tmpl('side.menu', {
                menuItems: this.menuItems,
                isUserLogged: user.isLoggedIn(),
                userName: user.get('userName'),
                previousLoginTime: user.get('previousLoginTime') && DateTime
                    .fromFormat(user.get('previousLoginTime'), 'yyyy-LL-dd HH:mm:ss.SSS', {zone: 'utc'})
                    .toLocal()
                    .toFormat('yyyy-LL-dd HH:mm:ss')
            }).replace());

            this.wrap = this.$('.fn-menu-wrap')[0];
            this.list = this.$('.fn-menu-list')[0];
        },

        close: function(callback) {
            // sun remove Playtech.API.page?.isPageInPopupUrl()
            if (!this.opened) {
                return;
            }

            scrollManager.enableScrolling(this);
            $(window).off('.menu');

            this.$el.addClass('close');

            this.transitionEnd(this.$('.fn-slide-menu-wrapper'), function() {
                this.$el.removeClass('open close');
                if (_.isFunction(callback)) {
                    callback();
                }
            }, this);

            this.removeOverlay();

            core.trigger('menu:action:leftMenuClosed');
            $('.fn-page').removeClass('page_state_menu-open');

            this.opened = false;
        },

        closeView: function() {
            BaseView.prototype.close.apply(this, arguments);
            this.removeOverlay();
        }
    });
});
